"use strict";

const { pyCall } = require("@Sk");
var PyDefUtils = require("PyDefUtils");

module.exports = function (pyModule) {
    pyModule["DesignTextBox"] = Sk.misceval.buildClass(
        pyModule,
        function ($gbl, $loc) {
            $loc["__init__"] = new Sk.builtin.func(
                PyDefUtils.withRawKwargs(function (kwargs, self) {
                    pyCall(pyModule["TextBox"].prototype["__init__"], [self], kwargs);
                    self._anvil.updateDesignName = updateDesignName;
                })
            );
        },
        "DesignTextBox",
        [pyModule["TextBox"]]
    );

    const oldTextSet = pyModule["DesignTextBox"].prototype._anvilClassic$propMap.text.set;
    const oldPlaceholderSet = pyModule["DesignTextBox"].prototype._anvilClassic$propMap.placeholder.set;

    function updateDesignName(s) {
        const textProp = s._anvil.getPropJS("text");
        const placeholderProp = s._anvil.getPropJS("placeholder");
        var e = s._anvil.element;
        if (!s._anvil.inlineEditing && !textProp && !placeholderProp) {
            e.addClass("anvil-designer-empty-component-message");
            e.val(s._anvil.designName);
            e.attr("placeholder", null);
        } else {
            e.removeClass("anvil-designer-empty-component-message");
            e.val(textProp);
            e.attr("placeholder", placeholderProp);
        }
    }

    pyModule["DesignTextBox"].prototype._anvilClassic$propMap["text"].set = function (s, e, v) {
        oldTextSet(s, e, v);
        updateDesignName(s);
    };
    // Override not to read back from the DOM
    pyModule["DesignTextBox"].prototype._anvilClassic$propMap["text"].get = undefined;

    pyModule["DesignTextBox"].prototype._anvilClassic$propMap["placeholder"].set = function (s, e, v) {
        oldPlaceholderSet(s, e, v);
        updateDesignName(s);
    };
    pyModule["DesignTextBox"].prototype._anvilClassic$propMap["placeholder"].get = undefined;
};
